// extracted by mini-css-extract-plugin
export default {"unit":"addInstitution_unit__u4odP"};